module.exports = __webpack_public_path__ + "static/img/1000000514.96fb7cc1.jpg";